export default "__VITE_ASSET__DazWTwRE__"